/**
 * The path argument should be relative to the project root and contain the filename.
 * For example: some/folder/here/file.js
 */
export function createFormDataBlob(path: string, content = '', type = 'text/plain') {
  const blobManifest = new Blob([content], { type });
  const formData = new FormData();
  formData.append('file', blobManifest, path);
  return formData;
}
